
export const accessToken = 'pk.eyJ1Ijoiam91cm5leXdvcmtzIiwiYSI6ImNqeHZ2bzB2ejA4ZXkzbW1sbTRtcjg4dTIifQ.OtmKmJbmtxuMvdt6mSCpPg'

export const mapStyle = 'mapbox://styles/journeyworks/ck83ntv5n05nq1ipg8pymjoch'

export const mapConfig = {
  zoom: 12.04,
  center: [4.701801, 51.767419]
}

export const planMode = true

export const layers = {
  hexagons: {
    url: 'mapbox://journeyworks.3xkqvemr',
    source: "gem1900_resultaat_per_hexagon-3hs6qt",
    active: true
  },
  hexagonCenterpoints: {
    url: "mapbox://",
    source: "",
    active: false
  },
  parking: {
    url: "mapbox://journeyworks.4rw8ae4e",
    source: "gem1900_parkeervlakken-6bkp09",
    active: true
  },
  trees: {
    url: "mapbox://journeyworks.1kn23961",
    source: "bomen-a0a2vk",
    active: true
  },
  chargingpoints: {
    url: "mapbox://journeyworks.9nc5x3kw",
    source: "gem1900_oplaadpalen-4zwle9",
    active: true
  },
  plannedchargingpoints: {
    active: planMode
  },
  fuelstations: {
    url: "mapbox://journeyworks.7ywyq4bv",
    source: "gem1900_tankstations-duozl2",
    active: true
  },
  border: {
    url: "mapbox://journeyworks.7spo626k",
    source: "gem1900_gemeentegrens-ca21hj",
    active: true
  },
  visitorlocations: {
    url: "mapbox://journeyworks.034w7l7i",
    source: "gem1900_bezoekers_hexid-1d1m7i",
    active: true
  },
  pplusr: {
    url: "mapbox://journeyworks.1tg3jpc4",
    source: "pplusr-9u3rj5",
    active: true
  },
  ls: {
    url: "mapbox://journeyworks.6atmanoh",
    source: "gem1900_laagspanning-3o89cu",
    active: true
  },
  ovkasten: {
    url: "mapbox://",
    source: "",
    active: false
  },
  lichtmasten: {
    url: "mapbox://journeyworks.c58g7wkx",
    source: "gem1900_Lichtmasten-3yx39v",
    active: true
  },
  verkeerstekens: {
    url: "mapbox://journeyworks.cy5hoar9",
    source: "gem1900_Verkeerstekens-1umhbc",
    active: true
  },
  straatmeubilair: {
    url: "mapbox://journeyworks.dmuiw77x",
    source: "gem1900_Straatmeubilair-6ekp2y",
    active: true
  },
  grondeigendom: {
    url: "mapbox://journeyworks.1ycououy",
    source: "gem1900_Grondeigendom-19xoqd",
    active: true
  }
}

